(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/product-page-onboarding/assets/javascripts/log.js') >= 0) return;  svs.modules.push('/templates/product-page-onboarding/assets/javascripts/log.js');
"use strict";

if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  module.exports = trinidad.logger('onboarding');
} else {
  const log = svs.core.log.getLogger('onboarding');
  setGlobal('svs.components.onboarding.core.log', log);
}

 })(window);